import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeader({ title, subtitle, icon, action }: SectionHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-primary-600">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}